var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconBusiness = function SvgIconBusiness(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.767,
    height: 28.58,
    viewBox: "0 0 28.767 28.58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.155,1506.33h-9.722a1.181,1.181,0,0,1-1.185-1.177v-7.3a2.363,2.363,0,0,1,2.37-2.354h22.525a2.362,2.362,0,0,1,2.372,2.354v7.3a1.181,1.181,0,0,1-1.185,1.177h-9.722",
    transform: "translate(-179.248 -1490.984)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,1496.262H186v-1.129a3.518,3.518,0,0,1,3.636-3.385h3.636a3.517,3.517,0,0,1,3.636,3.385Z",
    transform: "translate(-177.818 -1491.747)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.157,1501.5a.906.906,0,0,0-.909.9v2.708a2.727,2.727,0,0,0,5.453,0V1502.4a.905.905,0,0,0-.909-.9Z",
    transform: "translate(-177.341 -1489.763)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.645,1504.5l1.5,9.655a1.8,1.8,0,0,1-.418,1.45,1.824,1.824,0,0,1-1.38.63H181.317a1.819,1.819,0,0,1-1.379-.631,1.793,1.793,0,0,1-.417-1.449l1.493-9.655",
    transform: "translate(-179.195 -1489.153)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconBusiness.1b15e3eb.svg";
export { ForwardRef as ReactComponent };